import { get } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";

export const getProgressReportsList = (projectId: string) =>
  get(ENDPOINTS.PROGRESS_REPORTS.LIST(projectId));

export const getProgressReportDetail = (projectId: string, reportId: string) =>
  get(ENDPOINTS.PROGRESS_REPORTS.DETAIL(projectId, reportId));
